export const environment = {
  production: false,
  apiUrl: 'https://dev.api.expedienteavicena.com/api/v1',
  wsUrl: 'https://dev.api.expedienteavicena.com',
};
